import Vue from "vue";
import Vuex from "vuex";
import profile from "./modules/profile";
import lookup from "./modules/lookup";
import company from "./modules/company";
import team from "./modules/team";
import user from "./modules/user";
import survey from "./modules/survey";
import resource from "./modules/resource";
import task from "./modules/task";
import reporting from "./modules/reporting";
import engagement from "./modules/engagement";
import common from "./modules/common";
import billing from "./modules/billing";
import checkin from "./modules/checkin";
import goal from "./modules/goal";
import recognition from "./modules/recognition";
import review from "./modules/review";
import settings from "./modules/settings";
import annualreview from "./modules/annualreview";
import corecard from "./modules/corecard";
import pulse from "./modules/pulse";
import customer from "./modules/customer";
import corecoaches from "./modules/corecoaches";
import insights from "./modules/insights";
import integration from "./modules/integration";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    profile,
    company,
    lookup,
    team,
    user,
    survey,
    resource,
    task,
    reporting,
    engagement,
    common,
    billing,
    checkin,
    goal,
    recognition,
    review,
    settings,
    annualreview,
    corecard,
    pulse,
    customer,
    corecoaches,
    insights,
    integration
  }
});
